"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnRegisterScrollInfoService = void 0;
function getMain() {
    return document.getElementsByTagName('main')[0];
}
function onScroll() {
    var main = getMain();
    if (window.scrollInfoService !== undefined)
        if ((window.innerHeight + main.scrollTop) >= main.scrollHeight)
            window.scrollInfoService.invokeMethodAsync('OnScrollToBottom', main.scrollTop);
}
window.RegisterScrollInfoService = function (scrollInfoService) {
    window.scrollInfoService = scrollInfoService;
    getMain().addEventListener("scroll", onScroll);
};
window.UnRegisterScrollInfoService = UnRegisterScrollInfoService;
function UnRegisterScrollInfoService() {
    getMain().removeEventListener("scroll", onScroll);
    window.scrollInfoService = undefined;
}
exports.UnRegisterScrollInfoService = UnRegisterScrollInfoService;
